import React from 'react'
import moment from 'moment'
import { component_tool } from '@/tool'
let { WizDataTable, WizButton, WizModal } = component_tool

let componentName = 'topic'

const columns = self => {
  return [
    {
      title: '话题名称',
      name: 'title',
      dataIndex: 'title',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '状态',
      name: 'state',
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' }
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '关注数量',
      name: 'followCount',
      dataIndex: 'followCount',
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => self.jumpPage && self.jumpPage(
                'push',
                '/community/topic/follow',
                record
              )}
            >
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '帖子数量',
      name: 'messageCount',
      dataIndex: 'messageCount',
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton
              tooltip={text}
              onClick={() => self.jumpPage && self.jumpPage(
                'push',
                '/community/topic/invitation',
                record
              )}
            >
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '创建时间',
      name: 'createTime',
      dataIndex: 'createTime',
      tableItem: {}
    },
    {
      title: '有效日期',
      name: 'date',
      dataIndex: 'date',
      tableItem: {
        type: 'custom',
        render: (text, record) => {
          let { start, end } = record
          let value = start + ' ~ ' + end
          return <div >{value}</div>
        }
      },
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD'
      },
    },
    {
      title: '是否置顶',
      name: 'topping',
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ],
      tableItem: {},
    },
    {
      title: '状态',
      name: 'state',
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' }
      ],
      tableItem: {}
    }
  ]
}

const templateConfig = self => {
  return {
    keepInitApiParams: true,
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(self),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.date && value.date.length === 2) {
              value.start = moment(value.date[0]).format('YYYY-MM-DD')
              value.end = moment(value.date[1]).format('YYYY-MM-DD')
            }
            // delete value.date
            return value
          },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/community/topic/topicAdd'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update', 'enableOrDisable', 'look', 'topOrCancelTop'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: { children: '编辑'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/community/topic/topicUpd'
              }
            }
          },
          {
            key: 'enableOrDisable',
            custom: true,
            params: { children: '启用'},
            textFormat: {
              recordKey: 'state',
              dirt: { 1: '禁用', 0: '启用' }
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'enable',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${record['state'] === 0 ? '启用' : '禁用'}该话题吗？`
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    let { id, state } = record
                    callback && callback({
                      state: state === 1 ? 0 : 1,
                      id
                    })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            }
          },
          {
            key: 'topOrCancelTop',
            custom: true,
            params: { children: '置顶'},
            textFormat: {
              recordKey: 'topping',
              dirt: { 1: '取消置顶', 0: '置顶' }
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'topping',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${record['topping'] === 0 ? '置顶' : '取消置顶'}该话题吗？`
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    let { id, topping } = record
                    callback && callback({
                      topping: topping === 1 ? 0 : 1,
                      id
                    })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            }
          },
          {
            key: 'look',
            custom: true,
            params: { children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/community/topic/topicLook'
              }
            }
          }
        ]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  topping: {
    path: `${componentName}/topping`,
    payload: {
      key: `${componentName}@topping`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
